export default __webpack_public_path__ + "static/media/244.a2b1557d.png";